module.exports = function(options)
{
    return (function()
    {
        this.afterAdd = function() {}
        this.afterRemove = function() {}
        var markedAsRemoved = 'marked-as-removed';

        var form = this;


        form.formElement = document.querySelector(options.selectors.mainForm);
        form.totalFormsField = form.formElement.querySelector('[id$="TOTAL_FORMS"]');
        form.maxFormsField = form.formElement.querySelector('[id$="MAX_NUM_FORMS"]');
        form.addAllButton = form.formElement.querySelector(options.selectors.addAllButton);
        form.inlineWrapper = form.formElement.querySelector(options.selectors.inlineForm.parent);
        form.template = null;
        form.previouslyAdded = null;

        function initTemplate()
        {
            var templateElement = form.formElement.querySelector(options.selectors.emptyForm);
            form.template = templateElement.cloneNode(true);
            form.template.removeAttribute('id');
            form.template.classList.remove('hidden');

            var checkbox = form.template.querySelector('input[id$="DELETE"]');
            templateElement.parentElement.removeChild(templateElement); 

            var tempElement = document.createElement('div');
            tempElement.appendChild(form.template);

            form.template = tempElement.innerHTML;
        }

        function initExisting()
        {
            function createClickHandler(existing, removeButton, checkbox)
            {
                removeButton.addEventListener('click', function(e)
                {
                    checkbox.checked = !checkbox.checked;
                    existing.classList.toggle('marked-as-removed');
                });
            }

            var existingForms = form.inlineWrapper.querySelectorAll(options.selectors.inlineForm.self);

            var existing, removeButton, removeCheckbox;
            for(var i = 0; i < existingForms.length; i++)
            {
                existing = existingForms[i];
                removeButton = existing.querySelector(options.selectors.inlineForm.removeButton);
                removeCheckbox = existing.querySelector('input[id$="DELETE"]');
                createClickHandler(existing, removeButton, removeCheckbox);
            }
        }

        function intAddButton()
        {
            form.addButton = form.formElement.querySelector(options.selectors.addButton);
            form.addButton.addEventListener('click', onAddButtonClick);

            if (form.addAllButton)
            {
                form.addAllButton.addEventListener('click', function(e)
                {
                    var needed = parseInt(form.maxFormsField.value) - parseInt(form.totalFormsField.value);

                    for(var i = 0; i < needed; i++)
                    {
                        onAddButtonClick(null);
                    }
                });
            }
        }

        function formCountIncrement()
        {
            var newCount = parseInt(form.totalFormsField.value) + 1;
            form.totalFormsField.value = newCount;

            checkAddButtonAvailability();
            return newCount;
        }

        function formCountDecrement()
        {
            var newCount = parseInt(form.totalFormsField.value) - 1;
            form.totalFormsField.value = newCount;

            checkAddButtonAvailability();
            return newCount;
        }

        function onAddButtonClick(e)
        {
            var all = form.inlineWrapper.querySelectorAll(options.selectors.inlineForm.self);
            
            var previousForm;
            for(var i = all.length - 1; i > -1; i--)
            {
                previousForm = all[i];
                if (!previousForm.classList.contains('marked-as-removed'))
                {
                    break;
                }
            }

            var tempElement = document.createElement('div');

            var newCount = formCountIncrement();

            tempElement.innerHTML = form.template.replace(/__prefix__/g, (newCount - 1));

            var inlineForm = tempElement.firstChild;
            inlineForm.classList.add('inline-form-set');

            inlineForm.querySelector(options.selectors.inlineForm.removeButton).addEventListener('click', function(e)
            {   
                form.inlineWrapper.removeChild(inlineForm);
                formCountDecrement();
            });

            form.inlineWrapper.appendChild(inlineForm);

            form.afterAdd(inlineForm, previousForm);
            return inlineForm;
        }

        function checkAddButtonAvailability()
        {
            var disabled = parseInt(form.totalFormsField.value) >= parseInt(form.maxFormsField.value);

            if (form.addButton) { form.addButton.disabled = disabled; }
            if (form.addAllButton) { form.addAllButton.disabled = disabled; }
        }

        initExisting();
        initTemplate();
        intAddButton();
        checkAddButtonAvailability();
        form.addRow = function() {
            return onAddButtonClick(null);
        };
        return form;
    })();
}